import React, { useEffect, useState } from "react";
import CommonTitle from "../../../components/CommonTitle";
import light from "../../../assets/icons/light.webp";
import waterdrop from "../../../assets/icons/waterdrop.webp";
import FilterItem from "../../../components/FilterItem";
import Filters from "../../../components/Filters";
import ConsHistoryTable from "../../../components/cons_reg/ConsHistoryTable";
import TableStructure from "../../../components/TableScruture";
import { useNavigate, useParams } from "react-router-dom";
import { getAllUsers, getResourceHistory } from "../../../services/resources";
import LoadingPage from "../../../components/LoadingPage";
import { IS_LOCAL_ENV } from "../../../App";
import Notification from "../../../components/ui-elements/Notification";

//================================

const translatedResorce = {
  agua: "water",
  luz: "light",
};

const ResourceHistory = () => {
  const { resource } = useParams();
  IS_LOCAL_ENV && console.log("params: ", resource);
  const [loading, setLoading] = useState(true);
  const [loadingFilter, setLoadingFilter] = useState(true);
  const [data, setData] = useState([]);
  //=================table filters===========================

  const [selectPropsList, setSelectPropsList] = useState([
    {
      options: [],
      title: "Nombres",
      value: "",
      setValue: (e) => updateSelectProp(0, e),
      formatedValue: (val) => val,
      dbField: "user",
    },
    {
      isInput: true,
      title: "Cantidad(desde)",
      value: "",
      onChange: (e) => updateSelectProp(1, e),
      placeholder: "Buscar cantidad",
      inputType: "number",
      formatedValue: (val) => parseFloat(val),
      dbField: "quantity",
    },
    {
      isInput: true,
      title: "Fecha(desde)",
      value: "",
      onChange: (e) => updateSelectProp(2, e),
      inputType: "date",
      formatedValue: (val) => new Date(val).toISOString().split("T")[0],

      dbField: "dateAndTime",
    },
  ]);

  const updateSelectProp = (i, e) => {
    setSelectPropsList((prev) => {
      let temp = [...prev];
      temp[i].value = e.target.value;
      return temp;
    });
  };

  const [filterQueryObject, setFilterQueryObject] = useState({
    resource: { equals: translatedResorce[resource] },
  });

  //==============table sort prop==========================
  const [sortedProp, setSortedProp] = useState(null); //ej "name" o "-name"
  const [showTableLoader, setShowTableLoader] = useState(false);
  //=========pagination props====================
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  //
  const navigate = useNavigate();

  //=====================fetch data==========================
  useEffect(() => {
    if (resource != "agua" && resource != "luz") {
      navigate(`notfound`);
    } else {
      const fetchData = async () => {
        try {
          setShowTableLoader(true);
          const response =
            resource == "agua"
              ? await getResourceHistory(
                  currentPage,
                  sortedProp,
                  filterQueryObject
                )
              : await getResourceHistory(
                  currentPage,
                  sortedProp,
                  filterQueryObject
                );
          setData(response?.docs || []);
          setTotalPages(response?.totalPages || 1);
          setLoading(false);
          setShowTableLoader(false);
        } catch (err) {
          setLoading(false);
          setShowTableLoader(false);
          IS_LOCAL_ENV && console.error(err);
          Notification({
            title: "Error",
            text: `Algo salió mal...`,
            type: "Error",
          });
        }
      };
      fetchData();
    }
  }, [currentPage, sortedProp, filterQueryObject]);

  //====================filters================================

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await getAllUsers();
        let users = response.docs.map((user) => {
          return { text: user.name, value: user.id };
        });
        selectPropsList[0].options = users;
        setLoadingFilter(false);
      } catch (err) {
        IS_LOCAL_ENV && console.error(err);
      }
    };

    fetchUsers();
  }, []);

  const applyFilters = () => {
    let temp = [];

    temp = selectPropsList
      .filter((filter) => filter.value != "" && filter.dbField != "dateAndTime")
      .map((filter) => ({
        [filter.dbField]: {
          [filter.dbField == "quantity" ? "greater_than_equal" : "equals"]:
            filter.formatedValue(filter.value),
        },
      }));

    let dt = selectPropsList[2].value;
    if (dt != "") {
      const baseDate = new Date(dt);
      baseDate.setUTCHours(0, 0, 0, 0);
      const utcDate = new Date(baseDate.getTime() + 5 * 60 * 60 * 1000);
      temp.push({
        dateAndTime: {
          greater_than_equal: utcDate.toISOString(),
        },
      });
    }
    temp.push({
      resource: {
        equals: translatedResorce[resource],
      },
    });

    const filterQuery =
      temp.length > 1 ? { and: temp } : temp.length === 1 ? temp[0] : {};

    setFilterQueryObject(filterQuery);
  };

  //completar atributos en selectPropsList

  return (
    <div className="w-full flex flex-col h-full">
      <>
        <CommonTitle
          img={resource == "agua" ? waterdrop : light}
          title={`Historial de registro de consumo ${
            resource == "agua" ? "hídrico" : "eléctrico"
          }`}
          text={`Visualiza el historial del consumo de ${resource} que se realizó con frecuencia diaria.`}
        />
        <Filters applyFilters={applyFilters}>
          {!loadingFilter &&
            selectPropsList.map((props, i) => {
              return <FilterItem props={props} key={i} />;
            })}
        </Filters>
        {loading ? (
          <LoadingPage />
        ) : (
          <TableStructure
            showTableLoader={showTableLoader}
            paginationProps={{ currentPage, setCurrentPage, totalPages }}
            customMaxWidth={"max-w-[1000px]"}
          >
            <ConsHistoryTable
              data={data}
              updateSortedProp={(str) => setSortedProp(str)}
            />
          </TableStructure>
        )}
      </>
    </div>
  );
};

export default ResourceHistory;
